<template>
  <button
    :class="['x-button', $attrs.class, btnCls]"
    v-bind="omit($attrs, ['class'])"
  >
    <slot></slot>
  </button>
</template>
<script lang="ts" name="XButton" setup>
import { omit } from 'lodash-es'

const props = withDefaults(
  defineProps<{
    type?: string
    size?: string
  }>(),
  {
    type: 'default',
    size: 'm',
  }
)
const btnCls = computed(() => {
  return {
    [`type-${props.type}`]: true,
    [`size-${props.size}`]: true,
  }
})
</script>
<style lang="scss" scoped>
.x-button {
  cursor: pointer;
  border: none;
  text-align: center;
  &.type-blank {
    background-color: var(--back-0);
    border: 1px solid var(--back-5);
    display: block;
    width: 100%;
    color: var(--text-1);
    &:hover {
      color: var(--purple-5);
      border-color: var(--purple-5);
    }
  }
  &.type-default {
    background-color: var(--black-1);
    color: var(--text-0);
    &:hover {
      opacity: 0.9;
    }
  }
  &.size-xl {
    font-size: 14px;
    line-height: 20px;
    padding: 12px 80px;
    &.type-default {
      border-radius: 22px;
    }
  }
  &.size-l {
    font-size: 14px;
    padding: 12px 40px;
    line-height: 20px;
    &.type-default {
      border-radius: 22px;
    }
  }
  &.size-m {
    font-size: 14px;
    padding: 8px 32px;
    line-height: 20px;
    &.type-default {
      border-radius: 20px;
    }
    &.type-blank {
      border-radius: 8px;
    }
  }
}
</style>
